import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/safe-api-call';
import { ApiType, getApiClient } from '../axios-service/axios.config';
import { ApiResponse } from '../api-service/api-types.model';
import {
  ReportDocument,
  ReportListItemDto,
  ReportIssueRequest,
  UpdateReportStatusRequest,
  AddReportCommentRequest,
  SupportTicketRequest,
  SupportTicket,
} from '@shared/types/shared.model';

@Injectable({
  providedIn: 'root',
})
export class SharedRepository {
  private client = getApiClient(ApiType.Shared);

  constructor(private apiService: ApiService) {}

  async submitReport(req: ReportIssueRequest): Promise<ApiResponse<any>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.post<ApiResponse<any>>('/api/Report/submit', req);
      return response.data;
    }, 'Failed to submit error report');
  }

  async getMyReports(): Promise<ApiResponse<ReportListItemDto[]>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.get<ApiResponse<ReportListItemDto[]>>(
        '/api/Report/GetMyReports',
      );
      return response.data;
    }, 'Failed to get personal reports');
  }

  async getAllReports(): Promise<ApiResponse<ReportListItemDto[]>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.get<ApiResponse<ReportListItemDto[]>>(
        '/api/Report/GetAllReports',
      );
      return response.data;
    }, 'Failed to get all reports');
  }

  async getOrganizationReports(tenantCode: string): Promise<ApiResponse<ReportListItemDto[]>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.get<ApiResponse<ReportListItemDto[]>>(
        `/api/Report/GetOrganizationReports/${tenantCode}`,
      );
      return response.data;
    }, 'Failed to get organization reports');
  }

  async getReportById(reportId: string): Promise<ApiResponse<ReportDocument>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.get<ApiResponse<ReportDocument>>(
        `/api/Report/${reportId}`,
      );
      return response.data;
    }, 'Failed to get report details');
  }

  async updateReportStatus(req: UpdateReportStatusRequest): Promise<ApiResponse<any>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.put<ApiResponse<any>>('/api/Report/updateStatus', req);
      return response.data;
    }, 'Failed to update report status');
  }

  async addReportComment(req: AddReportCommentRequest): Promise<ApiResponse<any>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.post<ApiResponse<any>>('/api/Report/addComment', req);
      return response.data;
    }, 'Failed to add comment');
  }

  async createSupportTicket(req: SupportTicketRequest): Promise<ApiResponse<any>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.post<ApiResponse<any>>('/api/Public/CreateSupportTicket', req);
      return response.data;
    }, 'Failed to create support ticket');
  }

  async getSupportTickets(): Promise<ApiResponse<SupportTicket[]>> {
    return this.apiService.safeApiCall(async () => {
      const response = await this.client.get<ApiResponse<SupportTicket[]>>(
        '/api/Public/GetSupportTickets',
      );
      return response.data;
    }, 'Failed to get support tickets');
  }
}
